import type { SidebarPreferences } from '@erp/rpc';

/**
 * Route ids that changed, old → new.
 *
 * A saved sidebar layout names its items by route id, so a route that moves
 * in the tree (a new layout parent changes its id, not its URL) would drop
 * out of every customized sidebar and come back as a "new" item at the end.
 * Mapping the old id on read keeps it in the buyer's own section; the next
 * save writes the new id.
 */
export const ROUTE_ID_RENAMES: Readonly<Record<string, string>> = {
  // Moved under the procurement filter route, which owns the filters shared
  // by these screens.
  '/authenticated/procurement/forecast/summary':
    '/authenticated/procurement-filters/procurement/forecast/summary',
  '/authenticated/procurement/forecast/details':
    '/authenticated/procurement-filters/procurement/forecast/details',
  '/authenticated/procurement/replenishment':
    '/authenticated/procurement-filters/procurement/replenishment',
  '/authenticated/procurement/purchase-orders':
    '/authenticated/procurement-filters/procurement/purchase-orders',
};

function renameIds(ids: string[]): string[] {
  return ids.map((id) => ROUTE_ID_RENAMES[id] ?? id);
}

export function renameRouteIdsInPreferences(
  prefs: SidebarPreferences,
): SidebarPreferences {
  const { layout } = prefs;
  return {
    ...prefs,
    hiddenItems: renameIds(prefs.hiddenItems),
    layout: layout && {
      ...layout,
      sections: layout.sections.map((section) => ({
        ...section,
        itemIds: renameIds(section.itemIds),
      })),
      hiddenItemIds: renameIds(layout.hiddenItemIds),
      unusedItemIds: renameIds(layout.unusedItemIds),
    },
  };
}
